import Vue from 'vue'
import Router from 'vue-router'
const VueRouterPush = Router.prototype.push 
Vue.use(Router)
import login from '../views/login.vue'//微信登录
import index from '../views/index.vue'//首页查询
import search from '../views/search.vue'//搜索查询
import indexdetail from '../views/indexdetail.vue'//干货详情
import course from '../views/course.vue'//课程
import my from '../views/my.vue'//我的
import mylabel from '../views/mylabel.vue'//我的标签
import mycoupons from '../views/mycoupons.vue'//我的优惠卷
import recordList from '../views/recordList.vue'//课程购买记录列表
import ghList from '../views/ghList.vue'//课程购买记录列表
import share from '../views/share.vue'//课程购买记录列表
import active from '../views/active.vue'//活动
import activeList from '../views/activeList.vue'//活动列表
import schoolSearch from '../views/schoolSearch.vue'//搜索查询


Vue.use(Router)
export default new Router({
    // mode: 'abstract',
    routes: [
        {
            path: '/index',
            component: index,
            meta:{title:''}
        },
        {
            path: '/course',
            name:'course',
            component: course,
            meta:{title:'课程'}
        },
        {
            path: '/my',
            component: my,
            meta:{title:'我的'}
        },
        {
            path: '/mylabel',
            component: mylabel,
            meta:{title:'我的标签'}
        },
        {
            path: '/mycoupons',
            component: mycoupons,
            meta:{title:'我的优惠卷'}
        },
        {
            path: '/indexdetail',
            component: indexdetail,
            meta:{title:'职场小姨妈：只输出人话的干货'}
        },
        {
            path: '/recordList',
            component: recordList,
            meta:{title:'课程购买记录'}
        },
        {
            path: '/ghList',
            component: ghList,
            meta:{title:'干货购买记录'}
        },
        {
            path: '/login',
            component: login,
            meta:{title:'登录'}
        },
        {
            path: '/share',
            component: share,
            meta:{title:'帮我助力呀'}
        },
        {
            path: '/active',
            component: active,
            meta:{title:'活动'}
        },
        {
            path: '/search',
            component: search,
            meta:{title:'搜索'}
        },
        {
            path: '/schoolSearch',
            component: schoolSearch,
            meta:{title:'学校选择'}
        },
        {
            path: '/activeList',
            component: activeList,
            meta:{title:'活动列表'}
        },
        {
            path: '/',
            redirect: '/login'
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js